module.exports = __webpack_public_path__ + "static/ActivateShop-3ecf22d1a4ae2e9e4f47df0971d8c041.png";